import React from 'react';
import PropTypes from 'prop-types';
import styles from './JobsList.module.scss';

const JobsListItem = ({ link, text }) => {
  return (
    <>
      <li>
        <a href={link} title={text} className={styles.jobsListItem}>
          {text}
        </a>
      </li>
    </>
  );
};

JobsListItem.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
};

export default JobsListItem;
